// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { ChangePasswordForm } from '@medplum/react';
import type { JSX } from 'react';

export function ChangePasswordPage(): JSX.Element {
  return <ChangePasswordForm />;
}
